// progressMiddleware.js
import { startProgress, doneProgress } from "./nprogress";

const progressMiddleware = (store) => (next) => (action) => {
  startProgress();

  next(action); // Call the next middleware/reducer

  // Use setTimeout to simulate asynchronous operation
  setTimeout(() => {
    doneProgress(); // Stop the progress bar
  }, 1000); // Adjust this delay as necessary to reflect your async operation
};

export default progressMiddleware;
